import React from 'react'
import { Link, Outlet, useParams } from 'react-router-dom';

const Main = () => {
    const { seriesId } = useParams();

    return (
        <div className="Body">
            <div>{seriesId} Series</div>
            <nav>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center", listStyleType: "none", gap: "2rem", padding: "20px 0px 20px 0px"}}>
                    <li><Link to={""}>Info</Link></li>
                    <li><Link to={"calendar"}>Calendar</Link></li>
                    <li><Link to={"rules"}>Rules</Link></li>
                    <li><Link to={"results"}>Results</Link></li>
                    <li><Link to={"register"}>Register</Link></li>
                </div>
            </nav>
            <Outlet />
        </div>
    )
}

export default Main